import React, { Component } from "react";
import PropTypes, { instanceOf } from "prop-types";
import { withRouter } from "react-router-dom";
import qs from "qs";
import { withCookies, Cookies } from "react-cookie";
import { setCookieParams } from "utils/cookies";
import * as appConstants from "../../../config/constants";

class Authorize extends Component {
  componentDidMount() {
    const { cookies } = this.props;
    const parsedQs = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    const parsedHash = qs.parse(this.props.location.hash.slice(1));

    // If there is an access token present (this happens when Eden iframes in a page) persist it
    if (parsedQs.access_token) {
      cookies.set(
        appConstants.COOKIES.ADMIN_TOKEN,
        parsedQs.access_token,
        setCookieParams()
      );
    }

    if (window.frameElement && !parsedQs.access_token) {
      window.parent.postMessage(
        {
          authToken: parsedHash.access_token,
        },
        appConstants.FRONTEND_ROOT
      );
    }

    // If there is a next direction, go to it
    if (parsedQs.next) {
      window.location.href = parsedQs.next;
    }
  }

  render() {
    return <h2>Loading...</h2>;
  }
}

Authorize.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
  }),
  cookies: instanceOf(Cookies).isRequired,
};

const AuthorizeWithRouter = withRouter(Authorize);

export default withCookies(AuthorizeWithRouter);
